import styled from "styled-components";

export const StyledDiv = styled.div`
  margin-left: 1rem;
  margin-right: 1rem;
`;
